type Item = string | undefined;

const getRobotsContent = (arr: Item[]) => {
  return arr.filter((i) => Boolean(i)).join(", ");
};

export default getRobotsContent;
